<div
    class="clinic-logo"
    [ngStyle]="{'background-image': getLogo()}"
    [ngClass]="{'skeleton-item background-grey': initialLoading}"
></div>